import { FlaskConical, Lock, LifeBuoy } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleDateString("fr-CH") : "");

export function EssaiBanner({ acces, isAdmin, support, onExitSupport }) {
  if (support) {
    return (
      <div className="flex items-center gap-2 px-4 md:px-8 py-2 text-xs bg-sky-50 text-sky-900 border-b border-sky-200" data-testid="banner-support">
        <LifeBuoy size={14} className="shrink-0" />
        <span className="flex-1">Mode support MADLO — <strong>{support.agence_nom}</strong> en lecture seule (aucune modification possible). Tracé dans les notes de la gérance.</span>
        <button onClick={onExitSupport} className="underline font-medium" data-testid="banner-support-exit">Quitter</button>
      </div>
    );
  }
  if (!acces) return null;
  if (acces.phase === "essai" && isAdmin && acces.fin_essai) {
    return (
      <div className="flex items-center gap-2 px-4 md:px-8 py-2 text-xs bg-dd-light/70 text-dd-night border-b border-dd-light" data-testid="banner-essai">
        <FlaskConical size={14} className="text-dd-blue shrink-0" />
        <span>Version bêta — essai jusqu'au <strong>{fmt(acces.fin_essai)}</strong>{acces.jours_restants != null && acces.jours_restants <= 7 ? ` (${acces.jours_restants} jour${acces.jours_restants > 1 ? "s" : ""} restant${acces.jours_restants > 1 ? "s" : ""})` : ""}.</span>
      </div>
    );
  }
  if (acces.mode === "lecture") {
    return (
      <div className="flex items-center gap-2 px-4 md:px-8 py-2 text-xs bg-amber-50 text-amber-900 border-b border-amber-200" data-testid="banner-lecture">
        <Lock size={14} className="shrink-0" />
        <span>Période d'essai terminée : consultation et téléchargement uniquement jusqu'au <strong>{fmt(acces.fin_lecture)}</strong>. Ensuite le compte sera bloqué et les données non téléchargées supprimées. Contactez MADLO Constat pour activer votre compte.</span>
      </div>
    );
  }
  return null;
}
